import type { FormPaginationProps } from '@types';

export const getPaginationInfo = (headers: Record<string, string>): FormPaginationProps | null => {
  const paginationHeader = headers['x-pagination'] || headers['X-Pagination'];
  return paginationHeader ? JSON.parse(paginationHeader) : null;
};
